module.exports = __webpack_public_path__ + "static/media/road.32c8440b.svg";